module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "_1-CN",
    attrs: {
      "id": "_idParaDest-14"
    }
  }, [_c('span', {
    staticClass: "leading-139-5"
  }, [_vm._v("S")]), _vm._v("IX")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Opening"
  }, [_vm._v("It was just before six o’clock, three days after Thorne had met Nicola Tanner, when she called him. He was playing pool with Phil Hendricks in the Grafton Arms, a pub opposite his flat that had seen a good deal of their custom over the years.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("The landlord had made a good job of not looking too thrilled to see them back.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Thorne had driven to Kentish Town straight from work, ostensibly in response to a complaint from his tenants that the boiler was acting up. Thorne knew about as much about faulty boilers as he did about astrophysics. He’d taken no more than a glance at it and said, ‘I’ll get a plumber over,’ then, after a cursory look around – a few more stains on the carpet, some Coldplay CDs which made him feel like raising the rent immediately – he’d walked across the road to meet Phil.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("To relax and talk about nothing important for a while, to maybe win a few quid.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘We might have another one,’ Tanner said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Thorne said, ‘Right.’ Thinking: "), _c('span', {
    staticClass: "BT1_Body_text_1_Italic _idGenCharOverride-1"
  }, [_vm._v("Another what?")]), _vm._v(" Then: "), _c('span', {
    staticClass: "BT1_Body_text_1_Italic _idGenCharOverride-1"
  }, [_vm._v("We?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Hendricks chalked his cue and mouthed, ‘Who’s that?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Thorne shook his head, listened.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘A missing couple,’ Tanner said. ‘Bangladeshi. Families reported them missing two days ago.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘A couple?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘As far as honour crimes go, it’s not uncommon. A wife who runs away with another man. A girl who refuses to marry whoever her parents have promised her to and runs off with the boy she loves.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘How old are they?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘They’re both eighteen.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Well then, maybe it’s just that,’ Thorne said. ‘"), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v("Love")]), _vm._v("-"), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v("struck")]), _vm._v(" teenagers getting away from their families.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘In which case they might be in danger.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘So, now you’re investigating crimes before they happen?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘They might not be missing at all,’ Tanner said. There was a pause, for effect. ‘They have to be "), _c('span', {
    staticClass: "BT1_Body_text_1_Italic _idGenCharOverride-1"
  }, [_vm._v("reported")]), _vm._v(" missing, to avoid suspicion.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Thorne said nothing, watched Hendricks lining up his next shot.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Nobody’s taking it very seriously, that’s the thing, so I think we’ve got a good chance to look into this without putting too many backs up.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Except mine, Thorne thought.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Look, if you’re not interested—’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘I never said that.’ Thorne looked across at Hendricks and rolled his eyes. ‘I’m just assuming they’re not taking it seriously because it’s two adults, that’s all. There’s nothing to indicate anything sinister going on, is there?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Not at the moment. Nothing obvious.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Or anything to connect this to the Meena Athwal murder?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("There was silence for a few seconds. Thorne could hear Tanner’s frustration, anger even, crackling down the line.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘It would be a lot easier if we talked about this in person,’ she said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Thorne had the feeling he sometimes got arguing the toss with a senior officer. Though fighting losing battles was something of a speciality, on this occasion he simply couldn’t be arsed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("And Meena Athwal had been missing before she’d been found dead.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("He sighed out a ‘Fine’.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Any chance you could come over later?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Tomorrow no good?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Sooner the better.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘It’ll be late.’ Thorne looked at his watch. There was plenty of pool to be played yet. ‘What time do you go to bed?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘I’ll be up,’ Tanner said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("When he’d taken down the address and hung up, Thorne told Hendricks about the call and his meeting with Nicola Tanner in the Viaduct; her ideas about a team of hitmen carrying out honour killings to order. It took him about as long as it took Hendricks to polish off his remaining balls and casually pocket the black into the corner.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘You’ve been practising,’ Thorne said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Hendricks walked across and picked up his pint. He shook his head. ‘I still can’t get over Tanner being gay.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘She just keeps it a bit quieter than you,’ Thorne said. ‘Then again, so does Elton John.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Hendricks had known Tanner a while and had been the pathologist responsible for the "), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v("post")]), _vm._v("-"), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v("mortem")]), _vm._v(" on Heather Finlay. They had always enjoyed something of a spiky relationship at work, and back then he had actually told Thorne he thought Tanner was homophobic.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Thorne began gathering the balls from the pockets, rolling them down the table. ‘Must just be you she doesn’t like.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘It all seems slightly . . . tenuous,’ Hendricks said. ‘This missing persons business. Sounds like she might be a bit obsessed.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘She’s got every reason to be,’ Thorne said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘I suppose.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Pain can do that to people.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Hendricks began racking the balls, arranging the spots and stripes in their correct position within the triangle. ‘How’s Helen?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Thorne looked at him, but he understood immediately why his friend had made the connection between one kind of grief and another. Hendricks had been with them in Polesford. He was close to Helen and, Thorne suspected, someone she was more likely to confide in.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Yeah, she’s doing OK, I think.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Good.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Got her hands full with Alfie, but otherwise . . . you know.’ Thorne made a mental note to call Helen on his way to Tanner’s, to let her know he’d be late.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘She’ll be fine,’ Hendricks said. ‘She’s a scrapper.’ He smiled at what was coming, seemingly happy to move the conversation on to ground a little less heavy. ‘Well, she’d have to be, living with you.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Don’t you bloody start. The two of you been comparing notes?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘On the rocks, is it?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Are you going to break or not?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Hendricks picked up the white ball. ‘I can’t help feeling sorry for her, though. I mean, not exactly a match made in heaven for her, is it?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Like you’re such a bloody catch,’ Thorne said. ‘I’m surprised you haven’t turned Liam straight.’ It was ironic, considering the horrors of Polesford, that it had been where Hendricks had met Dr Liam Southworth, his current partner.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Hendricks just smiled and tossed the cue ball in the air; clearly still fully "), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v("loved")]), _vm._v("-"), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v("up")]), _vm._v(". He smacked the ball down on the table. ‘And "), _c('span', {
    staticClass: "BT1_Body_text_1_Italic _idGenCharOverride-1"
  }, [_vm._v("this")]), _vm._v(" isn’t much of a match either, mate. "), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v("Three")]), _vm._v("-"), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v("one")]), _vm._v(" now, is it?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘I’m hustling you.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Chance would be a fine thing,’ Hendricks said. He leaned down and broke, sending the balls scattering. A stripe dropped softly into one of the side pockets.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Jesus.’ Thorne picked up their glasses. ‘I’ll get them in, shall I?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Maybe you "), _c('span', {
    staticClass: "BT1_Body_text_1_Italic _idGenCharOverride-1"
  }, [_vm._v("should")]), _vm._v(" help Tanner out with this.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Thorne waited.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘She might be on to something.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Or she might just be obsessed, like you said.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Well then, just do it because it’s something different. A bit of a break or whatever.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Honour killings, right. Like a week in Barbados.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Hendricks was eyeing up his next shot. ‘OK, then, how about doing it because she’s asked you for a favour and you’re being nice.’ He leaned down. ‘"), _c('span', {
    staticClass: "BT1_Body_text_1_Italic _idGenCharOverride-1"
  }, [_vm._v("Nice")]), _vm._v(".’ He sank a second ball in the corner and grinned. ‘Look it up.’")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e54919e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBookVR024513.vue
// module id = 102
// module chunks = 0